import styled from 'styled-components';
import { SCREEN_SM } from 'shared/consts/styleValues';


export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 280px);
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 300px);
	}

	@media (min-width: 1024px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 372px);
	}
	@media (max-width: ${SCREEN_SM}px) {
    grid-template-columns: minmax(50px, auto);
	}
`;
